export const apiUrl = "https://api.sheetson.com/v2/sheets/";
export const sheetId = "1azmT8Mxf6QZltVhPZuKF5YUbUDcTvcNvh9FGs_1Y6MI";
export const keyApi = "vhCVpXCwUfRh0ixi1abSpP8yD4QbSswjBFqsGyKqjw5XWMYmt1E3kE7Ezug";
export const keyApiRead = "Y2qnhuLDgytlhlBP1OGWtX-YBln6OYmsQNG2n8HxQINVNYuquagv1Jsb2dEOBQ";